export default {
  async createProject(_, payload) {

   
    const response = await fetch(
      `https://myportfolio-min.runasp.net/api/projects`,
      {
        method: "POST",
        body: payload
      }
    );
    console.log(payload);

    if (!response.ok) {
      const error = new Error(
       "faild to send your message!"
      );

      throw error;
    }

  
  },

  // get all projects

  async getProjects(context) {
    const response = await fetch( 
      "https://myportfolio-min.runasp.net/api/projects"
    );

    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(responseData.message || "faild to get projects");

      throw error;
    }

    const projects = [];


    responseData.forEach(element => {
      projects.push(element)

    });
    context.commit("setProjects", projects);
  },

  // delete project by id

  async deleteProject(_, id) {
    const response = await fetch(
      `https://myportfolio-min.runasp.net/api/projects/${id}`,
      {
        method: "DELETE",
      }
    );

    if (!response.ok) {
      const error = new Error("Failed to delete project");
      throw error;
    }
  },
};
